// extracted by mini-css-extract-plugin
export default {"custom-menu-button":"CustomMenuButton_custom-menu-button__IVCO-","disabled-button":"CustomMenuButton_disabled-button__gfPme"};